import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        marginTop: 24
    },

    title: {
        fontSize: 36,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700',  
    },

    line: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 32,
        width: '100%'
    },
    box: {
        backgroundColor: "#FFC646",
        borderRadius: 12,
        paddingTop: 12,
        paddingBottom: 12,
        flexDirection: 'row',
        alignItems: 'center', // Alignement vertical correct
        paddingHorizontal: 10,
    },

    boxTitle: {
        fontSize: 12,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '500',  
    },

    boxSubTitle: {
        fontSize: 14,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '600',  
        marginTop: 0,
    },

    boxDescription: {
        fontSize: 16,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '400',
        marginTop: 38,
    },

    icon: {
       height: 32,
       width: 32,
       marginLeft: 12,
       marginRight: 8
    },

    logo: {
       height: 150,
       width: 200,
       alignSelf: 'flex-start',
       alignItems: 'flex-start'
    }
});